import type { ReactNode } from 'react';

import StatusBadge from 'components/base/StatusBadge';
import { ViewPlaceholder } from './ViewPlaceholder';

export interface ViewStatusProps {
  /** One status, or several (e.g. the statuses a trigger matches). */
  readonly value: string | readonly string[] | null | undefined;
  readonly placeholder?: ReactNode;
}

/** Node statuses, each as the same badge the lists use. */
export const ViewStatus = ({ value, placeholder }: ViewStatusProps) => {
  const statuses = (typeof value === 'string' ? [value] : (value ?? [])).filter((status) => status !== '');
  if (statuses.length === 0) return <ViewPlaceholder placeholder={placeholder} />;
  return (
    <span className="d-inline-flex flex-wrap gap-1">
      {statuses.map((status) => (
        <StatusBadge key={status} status={status} />
      ))}
    </span>
  );
};
